"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
var PermissionContext_1 = __importDefault(require("../../contexts/PermissionContext"));
var Permission = function (_a) {
    var viewPermission = _a.viewPermission, editPermission = _a.editPermission, deniedView = _a.deniedView, children = _a.children;
    var allowView = hooks_1.usePermission(viewPermission)[0];
    var allowEdit = hooks_1.usePermission(editPermission)[0];
    if (!allowView) {
        return deniedView ? react_1.default.createElement(react_1.default.Fragment, null, deniedView) : null;
    }
    return react_1.default.createElement(PermissionContext_1.default.Provider, { value: { allowView: allowView, allowEdit: allowEdit } }, children);
};
exports.withPermission = function (WrappedComponent, defaultDeniedView) {
    return function (props) {
        var viewPermission = props.viewPermission, editPermission = props.editPermission, deniedView = props.deniedView, rest = __rest(props, ["viewPermission", "editPermission", "deniedView"]);
        return (react_1.default.createElement(Permission, { viewPermission: viewPermission, editPermission: editPermission, deniedView: deniedView || defaultDeniedView },
            react_1.default.createElement(WrappedComponent, __assign({}, rest))));
    };
};
exports.default = Permission;
